import script from "./WelcomeIntro.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomeIntro.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomeIntro.vue?vue&type=style&index=0&id=fae91328&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fae91328"]])

export default __exports__